"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _htmlReactParser = _interopRequireDefault(require("html-react-parser"));

var _semanticUiReact = require("semantic-ui-react");

var _reactRouterDom = require("react-router-dom");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var CommunityListingTile = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(CommunityListingTile, _React$Component);

  function CommunityListingTile() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = CommunityListingTile.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        colour = _this$props.colour,
        image = _this$props.image,
        title = _this$props.title,
        summary = _this$props.summary,
        url = _this$props.url,
        accessInfo = _this$props.accessInfo;
    return /*#__PURE__*/React.createElement("div", {
      className: "community-tile",
      style: {
        borderTop: "3px solid " + colour
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "community-tile__image-wrapper"
    }, /*#__PURE__*/React.createElement("img", {
      className: "community-tile__image",
      src: image,
      alt: ""
    })), /*#__PURE__*/React.createElement("div", {
      className: "segment-tile--text"
    }, accessInfo && accessInfo.paidSubscriber && /*#__PURE__*/React.createElement(_reactRouterDom.Link, {
      to: url,
      className: "no-underline"
    }, /*#__PURE__*/React.createElement("h4", {
      className: "community-tile--title"
    }, (0, _htmlReactParser["default"])(title.replace('-', ' ')))), accessInfo && !accessInfo.paidSubscriber && /*#__PURE__*/React.createElement(_semanticUiReact.Popup, {
      trigger: /*#__PURE__*/React.createElement(_reactRouterDom.Link, {
        to: "#",
        className: "no-underline"
      }, /*#__PURE__*/React.createElement("h4", {
        className: "community-tile--title"
      }, (0, _htmlReactParser["default"])(title.replace('-', ' ')))),
      position: "top center",
      on: "click"
    }, /*#__PURE__*/React.createElement(_semanticUiReact.Popup.Content, null, "This is a paid subscriber feature. For more info please Contact Roy Morgan at", ' ', /*#__PURE__*/React.createElement("a", {
      href: "mailto:info@helixpersonas.com.au"
    }, "info@helixpersonas.com.au"))), /*#__PURE__*/React.createElement("div", {
      className: "community-tile--summary"
    }, (0, _htmlReactParser["default"])(summary))), /*#__PURE__*/React.createElement("div", {
      className: "community-tile-menu",
      style: {
        color: colour
      }
    }, this.props.children));
  };

  return CommunityListingTile;
}(React.Component);

var _default = CommunityListingTile;
exports["default"] = _default;